export default "__VITE_ASSET__DvCZF$6L__"